import { Train, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function TrainResultCard({ train, onSelect }) {
  const stopsLabel = train.stops === 0 ? "Direct" : `${train.stops} stop${train.stops > 1 ? "s" : ""}`;

  return (
    <div className="bg-card border border-border rounded-xl p-5 hover:shadow-md hover:border-primary/20 transition-all duration-200 group">
      {/* Operator row */}
      <div className="flex items-center gap-2 mb-3">
        <Train className="w-4 h-4 text-primary" />
        <span className="text-sm font-semibold text-foreground">{train.operator}</span>
        <span className="text-xs text-muted-foreground bg-muted px-2 py-0.5 rounded-full">{train.trainNumber}</span>
      </div>

      {/* Main row */}
      <div className="flex items-center justify-between gap-4 flex-wrap">
        {/* Departure */}
        <div className="min-w-[80px]">
          <p className="text-2xl font-bold tracking-tight">{train.departureTime}</p>
          <p className="text-xs text-muted-foreground mt-0.5">{train.origin}</p>
        </div>

        {/* Duration line */}
        <div className="flex-1 flex flex-col items-center min-w-[120px]">
          <p className="text-xs text-muted-foreground mb-1.5">{train.duration}</p>
          <div className="w-full flex items-center gap-1">
            <div className="h-[2px] flex-1 bg-border group-hover:bg-primary/30 transition-colors" />
            <ArrowRight className="w-3.5 h-3.5 text-muted-foreground group-hover:text-primary transition-colors" />
          </div>
          <p className="text-xs text-muted-foreground mt-1.5">{stopsLabel}</p>
        </div>

        {/* Arrival */}
        <div className="min-w-[80px] text-right">
          <p className="text-2xl font-bold tracking-tight">{train.arrivalTime}</p>
          <p className="text-xs text-muted-foreground mt-0.5">{train.destination}</p>
        </div>

        {/* Price + CTA */}
        <div className="flex flex-col items-end min-w-[130px] pl-4 border-l border-border">
          <p className="text-2xl font-bold text-primary">CHF {train.pricePerPerson.toFixed(0)}</p>
          <p className="text-xs text-muted-foreground mb-2">
            per person, {train.tripType === "round-trip" ? "round trip" : "one way"}
          </p>
          <Button
            type="button"
            size="sm"
            className="w-full"
            onClick={() => onSelect(train)}
          >
            Select
          </Button>
        </div>
      </div>
    </div>
  );
}